module.exports = __webpack_public_path__ + "media/blur-mob.4039e30e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blur-mob.jpg
// module id = 1136
// module chunks = 62